import React, {type FC, memo} from "react"
import {MANIFEST} from "@manifest/product-summary"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

interface ColourChipProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    linkUrl: string
    isSelected: boolean
    setMatchingColourWay: (itemNumber: string, index: number) => void
    itemNumber: string
    src: string
    className?: string
    dataSrc?: string
    id: string
    title: string
    price: string
    colour: string
    currencyCode: string
    department: string
    altText: string
    index: number
    firstItemNumber: string
    brand: string
    client: string
    slideIndex: (index: number) => void
}

export const ColourChipComponent: FC<ColourChipProps> = memo(
    ({
        templating,
        linkUrl,
        isSelected,
        setMatchingColourWay,
        itemNumber,
        src,
        className,
        dataSrc,
        id,
        title,
        price,
        colour,
        currencyCode,
        department,
        altText,
        firstItemNumber,
        brand,
        client,
        index,
        slideIndex,
    }) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST as any)
        const props = {
            linkUrl,
            isSelected,
            setMatchingColourWay,
            itemNumber,
            src,
            className,
            dataSrc,
            id,
            title,
            price,
            colour,
            currencyCode,
            department,
            altText,
            firstItemNumber,
            brand,
            client,
            index,
            slideIndex,
        }
        return <ComponentName {...props} />
    },
)
ColourChipComponent.displayName = "ColourChipComponent"

export default connect(ColourChipComponent)
